
export function getTransactionRequest(form , type_of_transaction) {
  if(Object.keys(form).length > 0){
    let userData = JSON.parse(localStorage.getItem("user")) 
    form.ngo_id = {id : userData.ngo.id , lookup_value : null}
    const keys = Object.keys(form);
    var req = new FormData();
    if(type_of_transaction !== 'un_known_branch'){
      req.append("implementation_governorate_id", userData.ngo.hq_id);
    }
    else{
      req.append("implementation_governorate_id", form.governorate_id.id);
    }
    // start logo_approval
    if(type_of_transaction === 'logo_approval'){
      delete form.ngo_id;
    }
    // end logo_approval
  
    req.append("slug", type_of_transaction);
    for (const index in keys) {
      const key = keys[index];
      console.log("key" , key)
      //  if(`${key}` === 'meeting_type_id'){
      if ((key.includes("_id") || key == 'governorate' || key == 'governorate_id' || key == 'campaign_type') && type_of_transaction !== 'complaint_and_objection_against_violation'  && type_of_transaction !== 'annual_plan_approval'   && type_of_transaction !== 'changing_the_board_of_directors_or_trustees'  && type_of_transaction !== 'un_known_branch'){
        if(Array.isArray(form[key])){
          // Extract ids and names
          const ids = form[key].map(item => item.id).join(', ');
          const names = form[key].map(item => item.name_ar).join(', ');
  
          // Construct the final object
          const transformedData = {
              "id": ids,
              "name_ar": names
          };
          req.append(`data[${index}][field_name]`, `${key}`);
          req.append(`data[${index}][field_value]`, transformedData.id);
          req.append(`data[${index}][lookup_value]`, transformedData?.name_ar );
        }
        else {
          req.append(`data[${index}][field_name]`, `${key}`);
          req.append(`data[${index}][field_value]`, form[key]?.id || form[key]?.value );
          req.append(`data[${index}][lookup_value]`, form[key]?.name_ar || form[key]?.name || form[key]?.meeting_minutes_label || form[key]?.name || form[key]?.title || form[key]?.number || form[key]?.account_no || form[key]?.employee_or_volunteer_label  );
        }
      }
  
      // start directors board
      else if(`${key}` === 'directors'){
        for (let i = 0; i < form.directors.length; i++) {
          let j = 0
          
          for (let el in form.directors[i]) {
            req.append(`data[director][${i}][${j}][field_name]`, `${el}`);
            if ((el.includes("_id"))){
              req.append(`data[director][${i}][${j}][field_value]`, form.directors[i][el]?.id || form.directors[i][el]?.value );
              req.append(`data[director][${i}][${j}][lookup_value]`, form.directors[i][el]?.name_ar || form.directors[i][el]?.name || form.directors[i][el]?.meeting_minutes_label || form.directors[i][el]?.name || form.directors[i][el]?.title || form.directors[i][el]?.number || form.directors[i][el]?.account_no  || form.directors[i][el]?.text     );
            }
            else if(j< Object.keys(form.directors[i]).length){
              req.append(`data[director][${i}][${j}][field_value]`, form.directors[i][el]);
            }
            j++
            req.append(`data[director][${i}][${j}][field_name]`, `ngo_id`);
            req.append(`data[director][${i}][${j}][field_value]`, `${form.ngo_id.id}`);
            req.append(`data[director][${i}][${j}][lookup_value]`, `${form.ngo_id.lookup_value}`);
            
          }
        }
      }
      else if(type_of_transaction === "changing_the_board_of_directors_or_trustees"){
        if(typeof counterDirector === 'undefined'){var counterDirector = 0}
        req.append(`data[directorBoards][${counterDirector}][field_name]`, `${key}`);
        if (key.includes("_id") || key == 'governorate' || key == 'campaign_type'){
          req.append(`data[directorBoards][${counterDirector}][field_value]`, form[key]?.id || form[key]?.value );
          req.append(`data[directorBoards][${counterDirector}][lookup_value]`, form[key]?.name_ar || form[key]?.name || form[key]?.meeting_minutes_label || form[key]?.name || form[key]?.title || form[key]?.number || form[key]?.account_no   );
        }
        else{
          req.append(`data[directorBoards][${counterDirector}][field_value]` , form[key]);
        }
        counterDirector++
      }
      // end directors board
  
      //  start complaint_and_objection_against_violation
      
      else if (type_of_transaction === 'complaint_and_objection_against_violation'){
        if(typeof counterComplain === 'undefined'){var counterComplain = 0}
        if (key.includes("_id") || key == 'governorate' || key == 'campaign_type'){
          req.append(`data[complaintAgainstViolation][${counterComplain}][field_name]`, `${key}`);
          req.append(`data[complaintAgainstViolation][${counterComplain}][field_value]`, form[key]?.id || form[key]?.value );
          req.append(`data[complaintAgainstViolation][${counterComplain}][lookup_value]`, form[key]?.name_ar || form[key]?.name || form[key]?.meeting_minutes_label || form[key]?.name || form[key]?.title || form[key]?.number || form[key]?.account_no   );
        }
        else if (`${key}` === 'files') {
          for (let i = 0; i < form.files.length; i++) {
              let j = 0
              for (let item in form.files[i]) {
                if (j < Object.keys(form.files[i]).length) {
                  req.append(`data[files][${i}][${j}][field_name]` , `${item}`);
                  req.append(`data[files][${i}][${j}][field_value]` , form.files[i][item]);
                  j++
                }
              }
          }
        }
        else{
          req.append(`data[complaintAgainstViolation][${counterComplain}][field_value]` , form[key]);
        } 
        counterComplain++
      }
      // end complaint_and_objection_against_violation
  
      // start annual_plan_approval
      else if(`${key}` === 'data' && type_of_transaction === "annual_plan_approval"){
        for (let i = 0; i < form.data.length; i++) {
          let j = 0
          for (let el in form.data[i]) {
            if ((el.includes("_id"))){
              if(Array.isArray(form.data[i][el])){
                // Extract ids and names
                const ids = form.data[i][el].map(item => item.id).join(', ');
                const names = form.data[i][el].map(item => item.name_ar).join(', ');
    
                // Construct the final object
                const transformedData = {
                    "id": ids,
                    "name_ar": names
                };
                req.append(`data[planActivities][${i}][${j}][field_name]`, `${el}`);
                req.append(`data[planActivities][${i}][${j}][field_value]`, transformedData.id);
                req.append(`data[planActivities][${i}][${j}][lookup_value]`, transformedData?.name_ar );
                j++
              }
              else {
                console.log('object' , key , form.data[i][el])
                req.append(`data[planActivities][${i}][${j}][field_name]`, `${el}`);
                req.append(`data[planActivities][${i}][${j}][field_value]`, form.data[i][el]?.id || form.data[i][el]?.value );
                req.append(`data[planActivities][${i}][${j}][lookup_value]`, form.data[i][el]?.name_ar || form.data[i][el]?.name || form.data[i][el]?.meeting_minutes_label || form.data[i][el]?.name || form.data[i][el]?.title || form.data[i][el]?.number || form.data[i][el]?.account_no  || form.data[i][el]?.text     );
                j++
              }
            }
            else if(j< Object.keys(form.data[i]).length){
              req.append(`data[planActivities][${i}][${j}][field_name]`, `${el}`);
              req.append(`data[planActivities][${i}][${j}][field_value]`, `${form.data[i][el]}`);
              j++
            }
          }
        }
      }
      else if(type_of_transaction === "annual_plan_approval"){
        if(typeof counter === 'undefined'){var counter = 0}
        if ((key.includes("_id"))){
          req.append(`data[plan][${counter}][field_name]`, `${key}`);
          req.append(`data[plan][${counter}][field_value]`, form[key]?.id || form[key]?.value );
          req.append(`data[plan][${counter}][lookup_value]`, form[key]?.name_ar || form[key]?.name || form[key]?.meeting_minutes_label || form[key]?.name || form[key]?.title || form[key]?.number || form[key]?.account_no  || form[key]?.text   );
          // }
        }
        else{
          req.append(`data[plan][${counter}][field_name]` , `${key}`);
          req.append(`data[plan][${counter}][field_value]` , form[key]);
        }
        counter++;
      }
      // end annual_plan_approval
    
      // start un_known_branch
      else if(`${key}` === 'administrativeCommittee'){
        for (let i = 0; i < form.administrativeCommittee.length; i++) {
          let j = 0;
          for (let item in form.administrativeCommittee[i]) {
            if ((item.includes("_id"))){
              req.append(`data[administrativeCommittee][${i}][${j}][field_name]`, `${item}`);
              req.append(`data[administrativeCommittee][${i}][${j}][field_value]`, form.administrativeCommittee[i][item]?.id || form.administrativeCommittee[i][item]?.value );
              req.append(`data[administrativeCommittee][${i}][${j}][lookup_value]`, form.administrativeCommittee[i][item]?.name_ar || form.administrativeCommittee[i][item]?.name || form.administrativeCommittee[i][item]?.meeting_minutes_label || form.administrativeCommittee[i][item]?.name || form.administrativeCommittee[i][item]?.title || form.administrativeCommittee[i][item]?.number || form.administrativeCommittee[i][item]?.account_no  || form.administrativeCommittee[i][item]?.text  || form.administrativeCommittee[i][item]?.employee_or_volunteer_label );
              j++
            }
            else if(j< Object.keys(form.administrativeCommittee[i]).length){
              req.append(`data[administrativeCommittee][${i}][${j}][field_name]`, `${item}`);
              req.append(`data[administrativeCommittee][${i}][${j}][field_value]`, form.administrativeCommittee[i][item]);
              j++;
            }
          }
        }
      }
      else if(type_of_transaction === "un_known_branch"){
        if(typeof counter === 'undefined'){var counter = 0}
        if ((key.includes("_id"))){
          console.log("key" , key)
          req.append(`data[branch][${counter}][field_name]`, `${key}`);
          req.append(`data[branch][${counter}][field_value]`, form[key]?.id || form[key]?.value );
          req.append(`data[branch][${counter}][lookup_value]`, form[key]?.name_ar || form[key]?.name || form[key]?.meeting_minutes_label || form[key]?.name || form[key]?.title || form[key]?.number || form[key]?.account_no  || form[key]?.text   );
        }
        else{
          req.append(`data[branch][${counter}][field_name]` , `${key}`);
          req.append(`data[branch][${counter}][field_value]` , form[key]);
        }
        counter++;
      }
      // end un_known_branch
      
      else if (`${key}` === 'ngo_name'){
      }
      else{
        req.append(`data[${index}][field_name]`, `${key}`);
        req.append(`data[${index}][field_value]`, form[key]);
      }
    }
    return req;
  }
  else{
    return null;

  }
}
export function getModifiedTransactionDataToSend(oldData , form , type_of_transaction ){
  console.log("old" , oldData)
  var req = new FormData();
  if(type_of_transaction !== 'un_known_branch'){
    req.append("implementation_governorate_id", form.implementation_governorate_id);
  }
  else{
    req.append("implementation_governorate_id", form.governorate_id.id);
  }
  
  delete form.implementation_governorate_id;
  const keys = Object.keys(form);
  req.append("slug", type_of_transaction);
  for (const index in keys) {
    const key = keys[index];
    // start logo_approval
    
    if(`${key}` === 'logo'){
      const results = oldData.filter(obj => obj['field_name'] === `${key}`)
      req.append(`data[${index}][field_name]`, `${key}`);
      req.append(`data[${index}][id]`, results[0].id);
      if(typeof form[key] == 'object'){
        const results = oldData.filter(obj => obj['field_name'] === `${key}`)
        req.append(`data[${index}][field_value]`, form[key]);
      }
    }
    // end logo_approval

    // start directors board
    else if(`${key}` === 'directors'){
      for (let i = 0; i < form.directors.length; i++) {
        let j = 0
        
        for (let el in form.directors[i]) {
          if ((el.includes("_id"))){
            req.append(`data[director][${i}][${j}][field_name]`, `${el}`);
            req.append(`data[director][${i}][${j}][field_value]`, form.directors[i][el]?.id || form.directors[i][el]?.value );
            req.append(`data[director][${i}][${j}][lookup_value]`, form.directors[i][el]?.name_ar || form.directors[i][el]?.name || form.directors[i][el]?.meeting_minutes_label || form.directors[i][el]?.name || form.directors[i][el]?.title || form.directors[i][el]?.number || form.directors[i][el]?.account_no  || form.directors[i][el]?.text     );
            const results = oldData.filter(obj => obj['field_name'] === `${el}` &&  obj['perant_id'] == `${i}` )
            req.append(`data[director][${i}][${j}][id]`, results[0].id);
          }
          else if ((el.includes("_file"))){
            if(typeof(form.directors[i][el]) === 'object'){
              req.append(`data[director][${i}][${j}][field_name]`, `${el}`);
              req.append(`data[director][${i}][${j}][field_value]`, form.directors[i][el]);
              const results = oldData.filter(obj => obj['field_name'] === `${el}` &&  obj['perant_id'] == `${i}` )
              req.append(`data[director][${i}][${j}][id]`, results[0].id);
            }
          }
          else if(j< Object.keys(form.directors[i]).length){
            req.append(`data[director][${i}][${j}][field_name]`, `${el}`);
            req.append(`data[director][${i}][${j}][field_value]`, form.directors[i][el]);
            const results = oldData.filter(obj => obj['field_name'] === `${el}` &&  obj['perant_id'] == `${i}` )
            req.append(`data[director][${i}][${j}][id]`, results[0].id);
          }
          
          j++
        }
      }
    }
    // start changing_the_board_of_directors_or_trustees
    else if(type_of_transaction === "changing_the_board_of_directors_or_trustees"){
      if(typeof counterDirector === 'undefined'){var counterDirector = 0}
      req.append(`data[directorBoards][${counterDirector}][field_name]`, `${key}`);
      if (key.includes("_id") || key == 'governorate' || key == 'campaign_type'){
        req.append(`data[directorBoards][${counterDirector}][field_value]`, form[key]?.id || form[key]?.value );
        req.append(`data[directorBoards][${counterDirector}][lookup_value]`, form[key]?.name_ar || form[key]?.name || form[key]?.meeting_minutes_label || form[key]?.name || form[key]?.title || form[key]?.number || form[key]?.account_no   );
      }
      else{
        req.append(`data[directorBoards][${counterDirector}][field_value]` , form[key]);
      }
      const results = oldData.filter(obj => obj['field_name'] === `${key}`)
      req.append(`data[directorBoards][${counterDirector}][id]`, results[0].id);
      counterDirector++
    }
    // end directors board

    // start annual_plan_approval
    else if(`${key}` === 'data' && type_of_transaction === "annual_plan_approval"){
    for (let i = 0; i < form.data.length; i++) {
        let j = 0
        for (let el in form.data[i]) {
          if ((el.includes("_id"))){
            if(Array.isArray(form.data[i][el])){
              console.log('array' , key , form.data[i][el])
              // Extract ids and names
              const ids = form.data[i][el].map(item => item.id).join(', ');
              const names = form.data[i][el].map(item => item.name_ar).join(', ');
  
              // Construct the final object
              const transformedData = {
                  "id": ids,
                  "name_ar": names
              };
              console.log("transformedData" , transformedData)
              req.append(`data[planActivities][${i}][${j}][field_name]`, `${el}`);
              req.append(`data[planActivities][${i}][${j}][field_value]`, transformedData.id);
              req.append(`data[planActivities][${i}][${j}][lookup_value]`, transformedData?.name_ar );
              // const results = oldData.filter(obj => obj['field_name'] === `${el}` &&  obj['perant_id'] == `${i}` )
              // req.append(`data[planActivities][${i}][${j}][id]`, results[0]?.id);
              // j++
            }
            else {
              console.log('object' , key , form.data[i][el])
              req.append(`data[planActivities][${i}][${j}][field_name]`, `${el}`);
              req.append(`data[planActivities][${i}][${j}][field_value]`, form.data[i][el]?.id || form.data[i][el]?.value );
              req.append(`data[planActivities][${i}][${j}][lookup_value]`, form.data[i][el]?.name_ar || form.data[i][el]?.name || form.data[i][el]?.meeting_minutes_label || form.data[i][el]?.name || form.data[i][el]?.title || form.data[i][el]?.number || form.data[i][el]?.account_no  || form.data[i][el]?.text     );
              // const results = oldData.filter(obj => obj['field_name'] === `${el}` &&  obj['perant_id'] == `${i}` )
              // req.append(`data[planActivities][${i}][${j}][id]`, results[0]?.id);
              // j++
            }
          }
          else if(j< Object.keys(form.data[i]).length){
            req.append(`data[planActivities][${i}][${j}][field_name]`, `${el}`);
            req.append(`data[planActivities][${i}][${j}][field_value]`, `${form.data[i][el]}`);
          }
          const results = oldData.filter(obj => obj['field_name'] === `${el}` &&  obj['perant_id'] == `${i}` )
          if(results.length !== 0){
            req.append(`data[planActivities][${i}][${j}][id]`, results[0]?.id);
          }
          j++
        }
      }
    }
    else if(type_of_transaction === "annual_plan_approval"){
      if(typeof counter === 'undefined'){var counter = 0}
      if ((key.includes("_id"))){
        req.append(`data[plan][${counter}][field_name]`, `${key}`);
        req.append(`data[plan][${counter}][field_value]`, form[key]?.id || form[key]?.value );
        req.append(`data[plan][${counter}][lookup_value]`, form[key]?.name_ar || form[key]?.name || form[key]?.meeting_minutes_label || form[key]?.name || form[key]?.title || form[key]?.number || form[key]?.account_no  || form[key]?.text   );
        // }
      }
      else{
        req.append(`data[plan][${counter}][field_name]` , `${key}`);
        req.append(`data[plan][${counter}][field_value]` , form[key]);
      }
      const results = oldData.filter(obj => obj['field_name'] === `${key}`)
      req.append(`data[plan][${counter}][id]`, results[0].id);
      counter++;
    }
    // end annual_plan_approval
    
    // start un_known_branch
    else if(`${key}` === 'administrativeCommittee'){
      for (let i = 0; i < form.administrativeCommittee.length; i++) {
        let j = 0;
        for (let item in form.administrativeCommittee[i]) {
          if(j< Object.keys(form.administrativeCommittee[i]).length){
            if ((item.includes("_id"))){
              req.append(`data[administrativeCommittee][${i}][${j}][field_name]`, `${item}`);
              req.append(`data[administrativeCommittee][${i}][${j}][field_value]`, form.administrativeCommittee[i][item]?.id || form.administrativeCommittee[i][item]?.value );
              req.append(`data[administrativeCommittee][${i}][${j}][lookup_value]`, form.administrativeCommittee[i][item]?.name_ar || form.administrativeCommittee[i][item]?.name || form.administrativeCommittee[i][item]?.meeting_minutes_label || form.administrativeCommittee[i][item]?.name || form.administrativeCommittee[i][item]?.title || form.administrativeCommittee[i][item]?.number || form.administrativeCommittee[i][item]?.account_no  || form.administrativeCommittee[i][item]?.text   || form.administrativeCommittee[i][item]?.employee_or_volunteer_label     );
              const results = oldData.filter(obj => obj['field_name'] === `${item}` &&  obj['perant_id'] == `${i}`)
              if(results.length !== 0){
                req.append(`data[administrativeCommittee][${i}][${j}][id]`, results[0].id);
              }
              j++;
            }
            // هون بهي الاف مو لازم خليه يزيد ع الجي كمان
            // else if(typeof form.administrativeCommittee[i][item] !== 'object' && `${item}` === 'security_dossier' ){}
            else if(typeof form.administrativeCommittee[i][item] === 'object' && `${item}` === 'security_dossier' ){
              req.append(`data[administrativeCommittee][${i}][${j}][field_name]`, `${item}`);
              req.append(`data[administrativeCommittee][${i}][${j}][field_value]`, form.administrativeCommittee[i][item]);
              const results = oldData.filter(obj => obj['field_name'] === `${item}` &&  obj['perant_id'] == `${i}`)
              if(results.length !== 0){
                req.append(`data[administrativeCommittee][${i}][${j}][id]`, results[0].id);
              }
              j++;
            }
          }
        }
      }
    }
    else if(type_of_transaction === "un_known_branch"){
      if(typeof counter === 'undefined'){var counter = 0}
      req.append(`data[branch][${counter}][field_name]`, `${key}`);
      if ((key.includes("_id"))){
        req.append(`data[branch][${counter}][field_value]`, form[key]?.id || form[key]?.value );
        req.append(`data[branch][${counter}][lookup_value]`, form[key]?.name_ar || form[key]?.name || form[key]?.meeting_minutes_label || form[key]?.name || form[key]?.title || form[key]?.number || form[key]?.account_no  || form[key]?.text   );
      }
      else{
        req.append(`data[branch][${counter}][field_value]`, form[key]);
      }
      const results = oldData.filter(obj => obj['field_name'] === `${key}`)
      req.append(`data[branch][${index}][id]`, results[0].id);
      counter++;
    }
    // end un_known_branch
    // start complaint_and_objection_against_violation
    else if (type_of_transaction === 'complaint_and_objection_against_violation'){
      if(typeof counterComplain === 'undefined'){var counterComplain = 0}
      
      if (key.includes("_id") || key == 'governorate' || key == 'campaign_type'){
        req.append(`data[complaintAgainstViolation][${counterComplain}][field_name]`, `${key}`);
        const results = oldData.filter(obj => obj['field_name'] === `${key}`)
        req.append(`data[complaintAgainstViolation][${counterComplain}][id]`, results[0].id);
        req.append(`data[complaintAgainstViolation][${counterComplain}][field_value]`, form[key]?.id || form[key]?.value);
        req.append(`data[complaintAgainstViolation][${counterComplain}][lookup_value]`, form[key]?.name_ar || form[key]?.name || form[key]?.meeting_minutes_label || form[key]?.name || form[key]?.title || form[key]?.number || form[key]?.account_no   );
      }
      else if (key == 'files'){
        console.log('files' ,form.files )
        for (let i = 0; i < form.files.length; i++) {
          let j = 0
            for (let item in form.files[i]) {
                if (j < Object.keys(form.files[i]).length) {

                    console.log(item + ': ' + form.files[i][item]);
                    req.append(`data[files][${i}][${j}][field_name]` , `${item}`);
                    if(`${item}` === 'file'){
                      if(typeof form.files[i][item] == 'object'){
                        req.append(`data[files][${i}][${j}][field_value]` , form.files[i][item]);
                      }
                    }
                    else{
                      req.append(`data[files][${i}][${j}][field_value]` , form.files[i][item]);
                    }
                    const results = oldData.filter(obj => obj['field_name'] === `${item}` &&  obj['perant_id'] == `${i}` )
                    console.log("results" , results)
                    if(results.length !== 0){
                      req.append(`data[files][${i}][${j}][id]`, results[0].id);
                    }
                    j++
                }
            }
          }
        }
      else{
        req.append(`data[complaintAgainstViolation][${counterComplain}][field_name]`, `${key}`);
        req.append(`data[complaintAgainstViolation][${counterComplain}][field_value]` , form[key]);
      } 
      counterComplain++
    }
    // end complaint_and_objection_against_violation
    else if (key.includes("_id") || key == 'governorate' || key == 'campaign_type'){
    if(Array.isArray(form[key])){
      // Extract ids and names
      const ids = form[key].map(item => item.id).join(', ');
      const names = form[key].map(item => item.name_ar).join(', ');

      // Construct the final object
      const transformedData = {
        "id": ids,
        "name_ar": names
      };
      req.append(`data[${index}][field_name]`, `${key}`);
      req.append(`data[${index}][field_value]`, transformedData.id);
      req.append(`data[${index}][lookup_value]`, transformedData?.name_ar );
      const results = oldData.filter(obj => obj['field_name'] === `${key}`)
      req.append(`data[${index}][id]`, results[0].id);
    }
    else {
      req.append(`data[${index}][field_name]`, `${key}`);
      req.append(`data[${index}][field_value]`, form[key]?.id || form[key]?.value );
      req.append(`data[${index}][lookup_value]`, form[key]?.name_ar || form[key]?.name || form[key]?.meeting_minutes_label || form[key]?.name || form[key]?.title || form[key]?.number || form[key]?.account_no   );
      const results = oldData.filter(obj => obj['field_name'] === `${key}`)
      req.append(`data[${index}][id]`, results[0].id);
    }
    }
    
    else if(`${key}` ==='file' || `${key}` ==='invitation_file' || `${key}` ==='inquiry_bulletin_file' || `${key}` ==='insurance_file' || `${key}` ==='bill_of_lading_file' || `${key}` ==='invoice_file' 
    ||  `${key}` ==='identification_file' || `${key}` ==='estate_document' || `${key}` ==='ownership_doc' || `${key}` === 'image'  || `${key}` === 'invitation_doc'
    || `${key}` === 'charter_doc' || `${key}` === 'internal_system_doc' || `${key}` === 'activities_and_funding_doc' || `${key}` === 'passports_doc') {

      const results = oldData.filter(obj => obj['field_name'] === `${key}`)
      if(typeof form[key] == 'object'){
        req.append(`data[${index}][field_name]`, `${key}`);
        req.append(`data[${index}][field_value]`, form[key]);
        if(results[0]?.id)
          req.append(`data[${index}][id]`, results[0].id);
      }
    }
    else if (`${key}` === 'ngo_name'){
    }
    else{
      if(`${form[key]}` !== 'null'){

        req.append(`data[${index}][field_name]`, `${key}`);
        req.append(`data[${index}][field_value]`, `${form[key]}`);
        console.log(`data[${index}][field_name]`, `${key}`)
        console.log(`data[${index}][field_value]`, `${form[key]}`)
        const results = oldData.filter(obj => obj['field_name'] === `${key}`)
        req.append(`data[${index}][id]`, results[0]?.id || null);
      }
    }
  }
  // }
  console.log("form dsds" , form)
  req.append("_method", "PUT");
  return req;
}
export function getModifiedTransactionData(type_of_transaction , transaction  ){
  const form = {};
  const requestData = transaction.transactionRequestData;

  const getFieldValue = (fieldName) => {
      const field = requestData.find(item => item.field_name === fieldName);
      return field ? field.field_value : null;
  };

  const getLookupValue = (fieldName) => {
      const field = requestData.find(item => item.field_name === fieldName);
      return field ? field.lookup_value : null;
  };

  const getFundraisingCampaign = () => {
    form.ngo_id = {id : getFieldValue('ngo_id') , lookup_value : null}
    form.name_ar           = getFieldValue('name_ar')
    form.image             = getFieldValue('image')
    form.campaign_amount   = getFieldValue('campaign_amount')
    form.count            = getFieldValue('count')
    form.start_date        = getFieldValue('start_date')
    form.end_date          = getFieldValue('end_date')
    form.governorate       =  { "id": parseInt(getFieldValue('governorate')), "name_ar": getLookupValue('governorate') } 
    form.description_ar    = getFieldValue('description_ar')
    form.campaign_type     = { "value": parseInt(getFieldValue('campaign_type')), "title": getLookupValue('campaign_type') } 
    let originalData = {
      "id": getFieldValue('age_category_id'),
      "name_ar": getLookupValue('age_category_id')
    };
    if(originalData.id  !== undefined && originalData.id )
      {
        let ids = originalData.id.split(',').map(id => id.trim());
        let names = originalData.name_ar.split(',').map(name => name.trim());
        
        let newData = ids.map((id, index) => {
            return {
                "id": parseInt(id),
                "name_ar": names[index]
            };
        });
        form.age_category_id = newData
      }
  };

  const getInternationalDonations = () =>{
    form.meeting_minute_id  = { "id": getFieldValue('meeting_minute_id'), "meeting_minutes_label": getLookupValue('meeting_minute_id') } 
    form.type               = getFieldValue('type')
    form.place_type         = getFieldValue('place_type')
    if(form.place_type === 'country'){
      form.country_id       = { "id": getFieldValue('country_id'), "name": getLookupValue('country_id') } 
      if(form.type !== 'bank_donations'){
        form.border_crossing_id = { "id": getFieldValue('border_crossing_id'), "name": getLookupValue('border_crossing_id') } 
      }
    }
    if(form.place_type === 'freezone'){
      form.free_zone_name   = getFieldValue('free_zone_name')
    }
    form.identification_file = getFieldValue('identification_file')
    if(form.type === 'bank_donations'){
      form.ngo_bank_account_id = { "id": getFieldValue('ngo_bank_account_id'), "account_no": getLookupValue('ngo_bank_account_id') } 
      form.donated_amount      = getFieldValue('donated_amount')
      form.currency_type_id    =  { "id": getFieldValue('currency_type_id'), "name_ar": getLookupValue('currency_type_id') } 
    }
    if(form.type === 'in_kind_donations'){
      form.description        = getFieldValue('description')
      form.donated_amount     = getFieldValue('donated_amount')
      // form.invoice_file       = getFieldValue('invoice_file')
      // form.bill_of_lading_file= getFieldValue('bill_of_lading_file')
      form.insurance_file     = getFieldValue('insurance_file')
    }
    if(form.type === 'machines'){
      form.machine_type_id    = { "id": getFieldValue('machine_type_id'), "name_ar": getLookupValue('machine_type_id') } 
      form.model              = getFieldValue('model')
      form.passengers_number  = getFieldValue('passengers_number')
      form.possessive_form_id =  { "id": getFieldValue('possessive_form_id'), "name_ar": getLookupValue('possessive_form_id') }
      form.structure_no       = getFieldValue('structure_no')
      form.year               = getFieldValue('year')
      form.fuel_type_id       = { "id": getFieldValue('fuel_type_id'), "name_ar": getLookupValue('fuel_type_id') } 
      form.engine_number      = getFieldValue('engine_number')
      form.color              = getFieldValue('color')
      form.ownership_doc      = getFieldValue('ownership_doc')
      form.tax                = parseInt(getFieldValue('tax'))
    }
  }

  const getMinutesOfAdministrativeMeetings = () => {
    form.title                = getFieldValue('title')
    form.meeting_date         = getFieldValue('meeting_date')
    form.meeting_type_id      = { "id": getFieldValue('meeting_type_id'), "name_ar": getLookupValue('meeting_type_id') } 
    form.attendance_names     = getFieldValue('attendance_names')
    form.file                 = getFieldValue('file')
  }

  const getMemberOfBoardOfDirectorsOrTrustees = ()=> {
    form.name                 = getFieldValue('name')
    form.switching_reason     = getFieldValue('switching_reason')
    form.meeting_minute_id    = { "id": getFieldValue('meeting_minute_id'), "meeting_minutes_label": getLookupValue('meeting_minute_id') }  
     form.old_director_id     = { "id": getFieldValue('old_director_id'), "name": getLookupValue('old_director_id')}  
    form.qualification_id     = { "id":getFieldValue('qualification_id'), "title": getLookupValue('qualification_id') } 
    form.job_title_id         = { "id": getFieldValue('job_title_id'), "name": getLookupValue('job_title_id')} 
    form.phone_number         = getFieldValue('phone_number')
    form.dob                  = getFieldValue('dob')
    form.ID_number            = getFieldValue('ID_number')
    form.director_board_id    = { "id": getFieldValue('director_board_id'), "name_ar": getLookupValue('director_board_id')} 
    form.inquiry_bulletin_file= getFieldValue('inquiry_bulletin_file')
  }
  
  const getCollaborationTwoLocalPartners = () => {
    form.partner_entity       = getFieldValue('partner_entity')
    form.partner_entity_name  = getFieldValue('partner_entity_name')
    form.duration             = getFieldValue('duration')
    form.goal_of_cooperation  = getFieldValue('goal_of_cooperation')
    form.file                 = getFieldValue('file')
  }

  const getFinancialGrantRequest = () =>{
    form.ngo_bank_account_id  =  { "id": getFieldValue('ngo_bank_account_id'), "account_no": getLookupValue('ngo_bank_account_id') }
    form.expenditures         = getFieldValue('expenditures')
  }

  const getHoldGeneralBodyMeeting = ()=>{
    form.meeting_minute_id    = { "id": getFieldValue('meeting_minute_id'), "meeting_minutes_label": getLookupValue('meeting_minute_id')} 
    form.first_meeting_date   = getFieldValue('first_meeting_date')
    form.second_meeting_date  = getFieldValue('second_meeting_date')
    form.meeting_location     = getFieldValue('meeting_location')
    form.general_authority_members_count = getFieldValue('general_authority_members_count')
    form.general_authority_members_who_can_attend_count = getFieldValue('general_authority_members_who_can_attend_count')
    form.business_schedule    = getFieldValue('business_schedule')
    form.does_meeting_include_nomination_of_board_members = getFieldValue('does_meeting_include_nomination_of_board_members')
    if(form.does_meeting_include_nomination_of_board_members == '1'){
      form.directors_board_candidates_membership_names = getFieldValue('directors_board_candidates_membership_names')
    }

  }

  const getNationalDonations = () =>{
    form.type                 = getFieldValue('type')
    if(form.type === 'machines'){
      form.machine_type_id    = { "id": getFieldValue('machine_type_id'), "name_ar": getLookupValue('machine_type_id')} 
      form.model              = getFieldValue('model')
      form.plate_number       = getFieldValue('plate_number')
      form.governorate_id     =  { "id": getFieldValue('governorate_id'), "name_ar": getLookupValue('governorate_id')}
      form.serial_number      = getFieldValue('serial_number')
      form.structure_no       = getFieldValue('structure_no')
      form.fuel_type_id       = { "id": getFieldValue('fuel_type_id'), "name_ar": getLookupValue('fuel_type_id')} 
      form.engine_number      = getFieldValue('engine_number')
      form.color              = getFieldValue('color')
      form.passengers_number  = getFieldValue('passengers_number')
      form.possessive_form_id =  { "id": getFieldValue('possessive_form_id'), "name_ar":getLookupValue('possessive_form_id')}
      form.ownership_doc      = getFieldValue('ownership_doc')
      form.tax                = getFieldValue('tax')
      form.year               = getFieldValue('year')
    }
    else{
      form.number = getFieldValue('number')
      form.estate_type_id     = { "id": getFieldValue('estate_type_id'), "name_ar": getLookupValue('estate_type_id')} 
      form.region             = getFieldValue('region')
      form.governorate_id     =  { "id": getFieldValue('governorate_id'), "name_ar": getLookupValue('governorate_id')}
      form.possessive_form_id =  { "id": getFieldValue('possessive_form_id'), "name_ar": getLookupValue('possessive_form_id')}
      form.is_operating       = getFieldValue('is_operating')
      form.estate_document    = getFieldValue('estate_document')
      form.equity_share       = getFieldValue('equity_share')
    }
  }

  const getTransferMoneyAbroads = () => {
    form.meeting_minute_id    = { "id": getFieldValue('meeting_minute_id'), "meeting_minutes_label": getLookupValue('meeting_minute_id') } 
    form.amount               = getFieldValue('amount')
    form.reason               = getFieldValue('reason')
    form.file                 = getFieldValue('file')
  }

  const getDissolutionOfAnNGO = () =>{
    form.meeting_minute_id    = { "id": getFieldValue('meeting_minute_id'), "meeting_minutes_label": getLookupValue('meeting_minute_id')} 
    form.name                 = getFieldValue('name')
    form.alternative_ngo_id   = { "id": getFieldValue('alternative_ngo_id'), "name_ar": getLookupValue('alternative_ngo_id')} 
  }

  const getInternationalEventsSubscriptions = ()=>{
    form.event_type           = getFieldValue('event_type')
    form.invitation_file      = getFieldValue('invitation_file')
    form.meeting_minute_id    = { "id": getFieldValue('meeting_minute_id'), "meeting_minutes_label": getLookupValue('meeting_minute_id')} 
    form.country_id           = { "id": getFieldValue('country_id'), "name": getLookupValue('country_id')} 
    form.address              = getFieldValue('address')
    form.start_date           = getFieldValue('start_date')
    form.end_date             = getFieldValue('end_date')
    form.organiser            = getFieldValue('organiser')
    form.objective            = getFieldValue('objective')
    form.other_invited_parties= getFieldValue('other_invited_parties')

  }
  
  const getOpenOffice = () => {
    form.meeting_minute_id    = { "id": getFieldValue('meeting_minute_id'), "meeting_minutes_label": getLookupValue('meeting_minute_id')} 
    form.governorate_id       = { "id": getFieldValue('governorate_id'), "name_ar": getLookupValue('governorate_id')}
    form.sub_district_id      =  { "id": getFieldValue('sub_district_id'), "name_ar": getLookupValue('sub_district_id')}
    form.address              = getFieldValue('address')
    form.real_estate_id       = { "id": getFieldValue('real_estate_id'), "number": getLookupValue('real_estate_id')}
    form.services             = getFieldValue('services')
    form.management_committee = getFieldValue('management_committee')
  }

  const getNnKnownBranch =()=>{
    form.meeting_minute_id   = { "id": getFieldValue('meeting_minute_id'), "meeting_minutes_label": getLookupValue('meeting_minute_id')} 
    form.governorate_id      = { "id": getFieldValue('governorate_id'), "name_ar": getLookupValue('governorate_id')}
    form.sub_district_id     = { "id": getFieldValue('sub_district_id'), "name_ar": getLookupValue('sub_district_id')}
    form.address             = getFieldValue('address')
    form.real_estate_id      = { "id": getFieldValue('real_estate_id'), "number": getLookupValue('real_estate_id')}
    form.services            = getFieldValue('services')
    form.latitude            = getFieldValue('latitude')
    form.longitude           = getFieldValue('longitude')
    form.administrativeCommittee = []
    const tempData = {};
    transaction.transactionRequestData.forEach(obj => {
      if (!tempData[obj.perant_id]) {
        tempData[obj.perant_id] = {};
      }
      if(obj.perant_id !== null){
        if(obj.field_name === 'employee_id')
        {
          tempData[obj.perant_id][obj.field_name] = { "id": obj.field_value, "employee_or_volunteer_label": obj.lookup_value } 
        }
        else{
          tempData[obj.perant_id][obj.field_name] = obj.field_value;
        }
      }
    });

    for (const key in tempData) {
      form.administrativeCommittee.push(tempData[key]);
    }
    form.administrativeCommittee = form.administrativeCommittee.filter(obj => Object.keys(obj).length !== 0)

  }

  const getMembershipApplicationToInternationalOrganization = () =>{
    form.meeting_minute_id   =  { "id": getFieldValue('meeting_minute_id'), "meeting_minutes_label": getLookupValue('meeting_minute_id')} 
    form.name                = getFieldValue('name')
    form.country_id          =  { "id": getFieldValue('country_id'), "name": getLookupValue('country_id')} 
    form.address             = getFieldValue('address')
    form.field_of_work       = getFieldValue('field_of_work')
    form.invitation_doc      = getFieldValue('invitation_doc')
    form.charter_doc         = getFieldValue('charter_doc')
    form.passports_doc       = getFieldValue('passports_doc')
    form.international_organization_goals = getFieldValue('international_organization_goals')
    form.international_organization_data = getFieldValue('international_organization_data')
    form.internal_system_doc= getFieldValue('internal_system_doc')
    form.latest_annual_report_doc = getFieldValue('latest_annual_report_doc')
    form.activities_and_funding_doc = getFieldValue('activities_and_funding_doc')
  }

  const getMergingTwoNgos = () =>{
    form.meeting_minute_id    = { "id": getFieldValue('meeting_minute_id'), "meeting_minutes_label": getLookupValue('meeting_minute_id')} 
    form.merged_ngo_id        =  { "id": getFieldValue('merged_ngo_id'), "name_ar": getLookupValue('meeting_minute_id')} 
    form.merger_resolution_number = getFieldValue('merger_resolution_number')
  }

  const getInternalSystemModificationRequests = () =>{
    form.meeting_minute_id      = { "id": getFieldValue('meeting_minute_id'), "meeting_minutes_label": getLookupValue('meeting_minute_id')} 
    form.objectives             = getFieldValue('objectives')
    form.term_of_office         = getFieldValue('term_of_office')
    form.board_members_count    = getFieldValue('board_members_count')
    form.name_ar                = getFieldValue('name_ar')
    form.name_en                = getFieldValue('name_en')
    form.modified_subject_numbers = getFieldValue('modified_subject_numbers')
    form.rejected_by_count      = getFieldValue('rejected_by_count')
    form.internal_system_doc    = getFieldValue('internal_system_doc')
    form.accepted_by_count      = getFieldValue('accepted_by_count')
    form.eligible_members_count = getFieldValue('eligible_members_count')
    form.attended_member_count  = getFieldValue('attended_member_count')
    form.ngo_id                 =  { "id": getFieldValue('ngo_id'), "lookup_value": getLookupValue('ngo_id')}
    let originalData = {
      "id": getFieldValue('governorate_id'),
      "name_ar": getLookupValue('governorate_id')
    };
    if(originalData.id  !== undefined && originalData.id )
    {
      let ids = originalData.id.split(',').map(id => id.trim());
      let names = originalData.name_ar.split(',').map(name => name.trim());
      let newData = ids.map((id, index) => {
          return {
              "id": parseInt(id),
              "name_ar": names[index]
          };
      });
      form.governorate_id = newData
    }
  }

  const getComplaintAndObjectionAgainstViolation = () =>{
    form.punishment_id        =  { "id": getFieldValue('punishment_id'), "name": getLookupValue('punishment_id')} 
    form.files = []
    const tempData = {};
    transaction.transactionRequestData.forEach(obj => {
      if (!tempData[obj.perant_id]) {
        tempData[obj.perant_id] = {};
      }
      if(obj.perant_id !== null){
        if(obj.field_name === 'employee_id')
        {
          tempData[obj.perant_id][obj.field_name] = parseInt(obj.field_value);
        }
        else{
        tempData[obj.perant_id][obj.field_name] = obj.field_value;
        }
      }
    });

    for (const key in tempData) {
      form.files.push(tempData[key]);
    }
    form.files = form.files.filter(obj => Object.keys(obj).length !== 0)

  }

  const getAnnualPlanApproval = () =>{
    form.ngo_id               =  { "id": getFieldValue('ngo_id'), "lookup_value": getLookupValue('ngo_id')} 
    form.year                 = getFieldValue('year')
    form.meeting_minute_id    = { "id": getFieldValue('meeting_minute_id'), "meeting_minutes_label": getLookupValue('meeting_minute_id')} 
    form.status               = parseInt(getFieldValue('status'))
    form.data = []
    const tempData = {};
    transaction.transactionRequestData.forEach(obj => {
      console.log("obj.field_name" , obj.field_name)
      if (!tempData[obj.perant_id]) {
        tempData[obj.perant_id] = {};
      }
      if(obj.perant_id !== null){
        if(obj.field_name === 'activity_id' || obj.field_name === 'program_id')
        {
          tempData[obj.perant_id][obj.field_name] = { "id": obj.field_value, "name": obj.lookup_value } 
        }
        else if(obj.field_name === 'months')
        {
          let x = obj.field_name
          tempData[obj.perant_id][obj.field_name] = (obj.field_value).split(",").map(Number);
        }
        else if(obj.field_name === 'governorate_id')
        {
          let x = obj.field_name
          let originalData = {
            "id": transaction.transactionRequestData.filter(item => item['field_name'] === x)[0].field_value,
            "name_ar": transaction.transactionRequestData.filter(item => item['field_name'] === x)[0].lookup_value
          };
          if(originalData.id  !== undefined && originalData.id )
            {
              // Split the values of "id" and "name_ar"
              let ids = originalData.id.split(',').map(id => id.trim());
              let names = originalData.name_ar.split(',').map(name => name.trim());
              
              // Create new objects with the split values
              let newData = ids.map((id, index) => {
                  return {
                    "id": parseInt(id),
                    "name_ar": names[index]
                  };
              });
              tempData[obj.perant_id][obj.field_name] = newData
          }
        }
        else{
          tempData[obj.perant_id][obj.field_name] = obj.field_value;
        }
      }
    });

    for (const key in tempData) {
      form.data.push(tempData[key]);
    }
    form.data = form.data.filter(obj => Object.keys(obj).length !== 0)

  }
  const getChangingTheBoardOfDirectorsOrTrustees = () =>{
    form.board_year = parseInt(getFieldValue('board_year'))
    form.term_of_office = parseInt(getFieldValue('term_of_office'))
    form.board_end_year = parseInt(getFieldValue('board_end_year'))
    form.ngo_id =  { "id": getFieldValue('ngo_id'), "lookup_value": getLookupValue('ngo_id')} 
    form.directors = []
    const tempData = {};
    transaction.transactionRequestData.forEach(obj => {
      if (!tempData[obj.perant_id]) {
        tempData[obj.perant_id] = {};
      }
      if(obj.perant_id !== null){
        if(obj.field_name === 'qualification_id')
        {
          tempData[obj.perant_id][obj.field_name] = { "id": obj.field_value, "title": obj.lookup_value } 
        }
        else if(obj.field_name === 'job_title_id')
        {
          tempData[obj.perant_id][obj.field_name] = { "id": obj.field_value, "name": obj.lookup_value } 
        }
        else if(obj.field_name === 'ngo_id')
        {
          tempData[obj.perant_id][obj.field_name] = { "id": obj.field_value, "name_ar": obj.lookup_value } 
        }
        else{

          tempData[obj.perant_id][obj.field_name] = obj.field_value
        }
      }
    });
    for (const key in tempData) {
      form.directors.push(tempData[key]);
    }
    form.directors = form.directors.filter(obj => Object.keys(obj).length !== 0)

  }
  form.implementation_governorate_id            = transaction.implementation_governorate_id
  if(type_of_transaction === "logo_approval"){
    form.logo = transaction.transactionRequestData[0].field_value
  }
  else if (type_of_transaction === "fundraising_campaign"){
    getFundraisingCampaign()
  }
  else if (type_of_transaction === "international_donations"){
    getInternationalDonations()
  }
  else if ( type_of_transaction === "minutes_of_administrative_meetings"){
    getMinutesOfAdministrativeMeetings()
  }
  else if (type_of_transaction === "member_of_board_of_directors_or_Trustees"){
    getMemberOfBoardOfDirectorsOrTrustees()
  }
  else if (type_of_transaction === "collaboration_two_local_partners"){
    getCollaborationTwoLocalPartners()
  }
  else if (type_of_transaction === "financial_grant_request"){
    getFinancialGrantRequest()
  }
  else if(type_of_transaction === "annual_plan_approval"){
    getAnnualPlanApproval()
  }
  else if(type_of_transaction === "hold_general_body_meeting"){
    getHoldGeneralBodyMeeting()
  }
  else if(type_of_transaction === "hold_general_body_meeting_2"){
    getHoldGeneralBodyMeeting()
  }
  else if(type_of_transaction === "changing_the_board_of_directors_or_trustees")
  {
    getChangingTheBoardOfDirectorsOrTrustees()
  }
  else if (type_of_transaction === "national_donations"){
    getNationalDonations()
  }
  else if (type_of_transaction === "transfer_money_abroads"){
    getTransferMoneyAbroads()
  }
  else if (type_of_transaction === "dissolution_of_an_NGO"){
    getDissolutionOfAnNGO()
  }
  else if (type_of_transaction === "international_events_subscriptions"){
    getInternationalEventsSubscriptions()
  }
  else if ( type_of_transaction === "open_office"){
    getOpenOffice()
  }
  else if ( type_of_transaction === "un_known_branch"){
    getNnKnownBranch()
  }
  else if (type_of_transaction === "membership_application_to_international_organization"){
    getMembershipApplicationToInternationalOrganization()
  }
  else if (type_of_transaction === "complaint_and_objection_against_violation"){
    getComplaintAndObjectionAgainstViolation()
  }
  else if (type_of_transaction === "merging_two_ngos"){
    getMergingTwoNgos()
  }
   else if (type_of_transaction === "internal_system_modification_requests"){
    getInternalSystemModificationRequests()
    
  }
  else if (type_of_transaction === "establishing_ngo"){
    form.est_ngo = transaction.establishmentNgo
  }
  console.log("forn after handel" , form)
  return form;
}